var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-header-widgets"},[_c('HeaderRates'),_vm._v(" "),_c('CommissionCalculatorModal',{staticClass:"global-header-widgets__calculator"}),_vm._v(" "),(_vm.isSuperadmin)?_c('NotificationBell',{staticClass:"global-header-widgets__bell"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0e3ca02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/GlobalHeaderWidgets.vue
// module id = null
// module chunks = 